// extracted by mini-css-extract-plugin
export default {"wrapper":"AIEAHQ","titles":"LNu56z","title":"fZLGdY","subtitle":"MLOphR","options":"ampUYf","option":"LvRJT9","arrow":"o3dkLU","optionTitle":"ELXufi"};